import {Artifact} from "../../../../types";
import {TrackedSearchResults} from "./TrackedSearchResults";
import {InitialSearchResults} from "./InitialSearchResults";
import {EmailDraftRenderer} from "./EmailDraftRenderer";
import {FallbackRenderer} from "./FallbackRenderer";
import {UserAttachmentRenderer} from "./UserAttachmentRenderer";
import {ATTACHMENT_ARTIFACT_TYPE} from "../../utils/pasteAttachments";

interface ArtifactRendererProps {
    artifact: Artifact;
    /** Assistant prose for this message; only the search_results renderer uses it. */
    messageContent?: string;
}

const artifactRenderers: Record<
    string,
    React.ComponentType<{artifact: Artifact; messageContent?: string}>
> = {
    search_results: TrackedSearchResults,
    email_draft: EmailDraftRenderer,
    [ATTACHMENT_ARTIFACT_TYPE]: UserAttachmentRenderer,
};

export function ArtifactRenderer({
    artifact,
    messageContent,
}: ArtifactRendererProps) {
    // Reading snapshots are request context, not answer cards.
    if (artifact.type === "reading_context") return null;
    const isInitialSearch =
        artifact.type === "search_results" &&
        typeof artifact.payload?.searchId === "string" &&
        typeof artifact.payload?.resultSetId === "string";
    const Renderer = isInitialSearch
        ? InitialSearchResults
        : artifactRenderers[artifact.type];

    if (!Renderer) {
        return (
            <div id={`artifact-${artifact.id}`}>
                <FallbackRenderer artifact={artifact} />
            </div>
        );
    }

    return (
        <div id={`artifact-${artifact.id}`}>
            <Renderer artifact={artifact} messageContent={messageContent} />
        </div>
    );
}
